import { observable } from '@aha-app/mvc';
import type WidgetsController from '../controllers/WidgetsController';
import type BaseWidget from '../widgets/BaseWidget';
import type TimerWidget from '../widgets/TimerWidget';
import type VotingSessionWidget from '../widgets/VotingSessionWidget';
import type ClientBase from './ClientBase';
import DataStore from './DataStore';

export type WidgetTypes = TimerWidget | VotingSessionWidget;

// Data store for fields
class DataStoreWidgets extends DataStore<BaseWidget> {
  constructor(public controller: WidgetsController, client: ClientBase) {
    super('widgets', client);
  }

  addRecord(record: WidgetTypes) {
    record = observable(record);
    super.addRecord(record);

    this.controller.restoreWidget(record);
    return record;
  }

  removeRecord(record: WidgetTypes): void {
    record = observable(record);
    super.removeRecord(record);

    this.controller.removeWidget(record);
  }
}

export default DataStoreWidgets;
